export interface UrgencyWindow {
  weekday: string;
  start: string;
  end: string;
}

export interface UrgencyPolicyConfig {
  version: 1;
  accepts_urgent_cases: boolean | null;
  paid_separately: boolean | null;
  approved_price_text: string | null;
  same_day_fit: 'yes' | 'no' | 'not_configured';
  on_call_windows: UrgencyWindow[];
  holiday_policy: string | null;
}

export const EMPTY_URGENCY_POLICY: UrgencyPolicyConfig = {
  version: 1,
  accepts_urgent_cases: null,
  paid_separately: null,
  approved_price_text: null,
  same_day_fit: 'not_configured',
  on_call_windows: [],
  holiday_policy: null,
};

export function mergeSchedulingConfig(
  existing: Record<string, any> | null | undefined,
  updates: Record<string, any>,
): Record<string, any> {
  const current = existing && typeof existing === 'object' ? existing : {};
  const merged = { ...current, ...updates };
  const currentUrgency = current.urgency && typeof current.urgency === 'object'
    ? current.urgency
    : {};
  const updatedUrgency = updates.urgency && typeof updates.urgency === 'object'
    ? updates.urgency
    : {};
  merged.urgency = { ...currentUrgency, ...updatedUrgency, version: 1 };
  return merged;
}
